import React from 'react';
import { MapPin } from 'lucide-react'; // Import the location icon

const JobCard = ({ careerData }) => {
  const data = careerData.Jobs; // Access the Jobs array
  const title = careerData.title || "Default Title"; // Fallback for title
  const subtitle = careerData.subtitle || "Default Subtitle"; // Fallback for subtitle

  return (
    <div className="w-full flex justify-center mt-5">
      {/* Centered Container for Content */}
      <div className="w-full flex gap-14 flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6 px-2 md:px-0">
        {/* Title and Subtitle */}
        <div className="text-black flex flex-col justify-center items-center">
          <p className="text-3xl sm:text-4xl md:text-5xl font-semibold">{title}</p>
          <p className="text-base sm:text-lg md:text-xl">{subtitle}</p>
        </div>

        {/* Jobs List */}
        <div className="mt-10 flex justify-center">
          <div className="w-full md:w-[60%] mb-20">
            {data && data.length > 0 ? (
              <div>
                {data.map((item, index) => (
                  <div
                    key={index}
                    className="p-4 mb-4 bg-white border flex items-center justify-between border-gray-300 rounded-md shadow-md"
                  >
                    <div className="flex">
                      <img
                        src={item.jobimage}
                        alt={item.title}
                        className="h-[100px] w-[100px] object-cover rounded-full"
                      />
                      <div className="flex flex-col justify-center mt-4">
                        <h3 className="text-lg font-medium">{item.title}</h3>
                        <div className="flex">
                          <MapPin className="text-gray-600 w-4 h-4 mt-1" /> {/* Location Icon */}
                          <p className="text-gray-600">{item.location}</p>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`text-white text-sm p-2 ${
                        item.jobtype === 'Fulltime' ? 'bg-green-600' : 'bg-red-500'
                      }`}
                    >
                      {item.jobtype}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className=" mb-4 flex  justify-center ">
                <p className=" text-2xl font-medium">Hiring Will Starts Soon..</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
